import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OrderService } from 'src/app/service/order.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { ImageProcessComponent } from '../modal/image-process/image-process.component';

@Component({
  selector: 'app-profile-form',
  templateUrl: './profile-form.component.html',
  styleUrls: ['./profile-form.component.scss']
})
export class ProfileFormComponent implements OnInit {

  @Output() updateEvent = new EventEmitter<string>();
  @Input() inWizard: boolean;

  profileForm = this.fb.group({
    avatar: new FormControl(''),
    emailReferens: new FormControl(''),
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    address: new FormControl(''),
    zipcode: new FormControl(''),
    city: new FormControl(''),
    country: new FormControl('', Validators.required),
    province: new FormControl(''),
    phone: new FormControl(''),
    company: new FormControl(''),
    vat: new FormControl(''),
    newsletter: new FormControl(''),
  });
  userId: string;
  avatar: any = './assets/image/profile.svg'
  profileData: any;
  countries: any = [];
  //declaring province to avoid error
  selectedCountry: any = {
    province: []
  };
  provinces: any = [];

  imgURL

  useremail: string = null;
  uid: string;
  profileUrl: any;
  downloadURL: any;
  constructor(
    public matDialog: MatDialog,
    private profileService: ProfileService, private afs: AuthService,
    private orderService: OrderService,
    private fb: FormBuilder,
    private storage: AngularFireStorage
  ) { }


  updateProfile() {
    console.log(this.profileForm.value)
    this.profileService.updateProfile(this.profileForm.value).then((res) => {
      this.updateEvent.emit('Updated')
    }, err => console.log(err)) // Show err
  }

  imageProcess() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = true;
    dialogConfig.id = "image-process-component";
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = {
      type: 'node-avatar'
    }
    const modalDialog = this.matDialog.open(ImageProcessComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.avatar = result;
        console.log(result.split('data:image/png;base64,')[1])
        // this.storage
        const filePath = `profiles/${this.uid}`;
        const ref = this.storage.ref(filePath);
        // const task = ref.putString(file);
        ref.putString(result.split('data:image/png;base64,')[1], 'base64').then(function (snapshot) {
          console.log(snapshot)
          console.log('Uploaded a base64url string!');
        }, err => console.log(err))
      }
    });
  }


  onChanges(): void {
    this.profileForm.get('country').valueChanges.subscribe(country => {
      this.countries.forEach(element => {
        if (element.country == country) {
          this.selectedCountry = element;
        }
      });
      if (this.selectedCountry.province.length <= 0) {
        this.profileForm.patchValue({
          province: ''
        });
      }
      else {
        console.log(this.selectedCountry.province[0].name)
        this.profileForm.patchValue({
          province: this.selectedCountry.province[0].name
        });
      }
    })
  }

  ngOnInit(): void {

    this.orderService.getCountries().then((ca: any) => {
      let countries = ca.sort((a, b) => (a.country < b.country) ? -1 : 1);

      this.orderService.getProvinces().then((res: any) => {
        this.provinces = res.sort((a, b) => (a.name < b.name) ? -1 : 1);;
        countries.forEach(country => {
          country.province = [];
          this.provinces.forEach(province => {
            if (country.alpha2_code == province.alpha2_code) {
              country.province.push(province);
            }
          });
          this.countries.push(country)
        });
      });
    }, err => {
      console.log(err)
    } // Show error
    )

    this.profileService.getUserProfile().subscribe((profile: any) => {
      const profileData = profile.payload.data();
      this.uid = profileData.uid
      this.useremail = profileData.email;
      this.profileForm.patchValue(
        {
          firstName: profileData.firstName || '',
          lastName: profileData.lastName || '',
          address: profileData.address || '',
          zipcode: profileData.zipcode || '',
          city: profileData.city || '',
          country: profileData.country || '',
          phone: profileData.phone || '',
          company: profileData.company || '',
          vat: profileData.vat || '',
          newsletter: profileData.newsletter || false,
        }
      );
      this.userId = profileData.uid

      const ref = this.storage.ref(`profiles/${this.uid}`);
      this.downloadURL = ref.getDownloadURL().subscribe((res) => {
        console.log(res)
        this.avatar = res;
      })

    }, err => {
      console.log(err)
    })
    this.onChanges();
  }

  get firstName() { return this.profileForm.get('firstName'); }
  get lastName() { return this.profileForm.get('lastName'); }
  get country() { return this.profileForm.get('country'); }


}
